import { pages } from '@content/prerender/pages';
import LayoutLegal from '@layouts/LayoutLegal';

const PageDocument = () => import('@pages/document/PageDocument');

export default [
    {
        path: '/',
        component: LayoutLegal,
        children: pages.map((page) => ({
            path: page.path.replace(/^\//, ''),
            name: page.name,
            component: PageDocument,
            meta: {
                document: page.name,
            },
        })),
    },
];
